import { rgba } from "polished";
import React, { FunctionComponent } from "react";
import { useTheme } from "styled-components";

interface StatusIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  type?: "up" | "down" | "equal";
}

const StatusIcon: FunctionComponent<StatusIconProps> = ({
  className,
  type = "up",
  ...props
}) => {
  const theme = useTheme();

  const getCircleColor = () => {
    switch (type) {
      case "up":
        return theme.colors.success;
      case "down":
        return theme.colors.accent;
      case "equal":
        return rgba(theme.colors.white, 0.25);
      default:
        return theme.colors.success;
    }
  };
  return (
    <svg
      className={className || ""}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      width="12"
      height="12"
      {...props}
    >
      <path
        fill={getCircleColor()}
        d="M6,0h0c3.31,0,6,2.69,6,6h0c0,3.31-2.69,6-6,6h0c-3.31,0-6-2.69-6-6h0C0,2.69,2.69,0,6,0Z"
      />
      {type === "equal" ? (
        <g>
          <path
            fill={theme.colors.white}
            d="M8,8.51h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1,.45,1,1s-.45,1-1,1Z"
          />
          <path
            fill={theme.colors.white}
            d="M8,5.49h-4c-.55,0-1-.45-1-1s.45-1,1-1h4c.55,0,1,.45,1,1s-.45,1-1,1Z"
          />
        </g>
      ) : (
        <path
          fill={theme.colors.white}
          style={{
            transform: type === "down" ? "rotate(180deg)" : "",
            transformOrigin: "center center",
          }}
          d="M8,8c-.26,0-.51-.1-.71-.29l-1.29-1.29-1.29,1.29c-.39.39-1.02.39-1.41,0s-.39-1.02,0-1.41l2-2c.39-.39,1.02-.39,1.41,0l2,2c.39.39.39,1.02,0,1.41-.2.2-.45.29-.71.29Z"
        />
      )}
    </svg>
  );
};

export default StatusIcon;
